import { create } from 'zustand';

type SetRunEditOpenArgs = { createMode: true } | { createMode: false; evalId: string };

export const NO_DATA_SOURCE = {
  type: 'Choose a data source',
  id: 'NONE'
} as const;

type NoEvalDataSource = typeof NO_DATA_SOURCE;
type TranscriptEvalDataSource = {
  type: 'Transcript';
  id: string;
  name: string;
};
type TranscriptTagEvalDataSource = {
  type: 'Transcript Tag';
  id: string;
  name: string;
};
type SessionEvalDataSource = {
  type: 'Session ID';
  id: string;
};
type RawEvalDataSource = {
  type: 'Raw';
  id: string;
};
export type EvalDataSource =
  | NoEvalDataSource
  | TranscriptEvalDataSource
  | TranscriptTagEvalDataSource
  | SessionEvalDataSource
  | RawEvalDataSource;

type AgentEvalStore = {
  runEditOpen: boolean;
  runEditCreateMode: boolean;
  runEditEvalId: string | null;
  dataSource: EvalDataSource;
  dataSourceOptions: EvalDataSource[];
  sessionId: string;

  setRunEditOpen: (args: SetRunEditOpenArgs) => void;
  closeModal: () => void;
  setDataSource: (id: string) => void;
  setDataSourceOptions: (dataSources: EvalDataSource[]) => void;
  setSessionId: (sessionId: string) => void;
};

export const useAgentEvalStore = create<AgentEvalStore>((set, get) => ({
  runEditOpen: false,
  runEditCreateMode: true,
  runEditEvalId: null,
  dataSource: NO_DATA_SOURCE,
  dataSourceOptions: [],
  sessionId: '',

  setRunEditOpen(args) {
    set({
      runEditOpen: true,
      runEditCreateMode: args.createMode,
      runEditEvalId: 'evalId' in args ? args.evalId : null
    });
  },

  closeModal() {
    set({ runEditOpen: false });
  },

  setDataSource(id: string) {
    const { dataSourceOptions } = get();
    const dataSource = dataSourceOptions.find((dataSource) => dataSource.id === id);
    set({ dataSource: dataSource ? dataSource : NO_DATA_SOURCE });
  },

  setDataSourceOptions: (dataSourceOptions: EvalDataSource[]) => {
    set({ dataSourceOptions });
  },

  setSessionId: (sessionId: string) => {
    set({ sessionId });
  }
}));
